import { render, staticRenderFns } from "./ForgetThePassword.vue?vue&type=template&id=ac694b48&scoped=true"
import script from "./ForgetThePassword.vue?vue&type=script&lang=js"
export * from "./ForgetThePassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac694b48",
  null
  
)

export default component.exports